function TextField() {
  return {
    MuiTextField: {
      defaultProps: {
        size: 'small',
        fullWidth: true,
      },
    },
  };
}

export default TextField;
